export * from './taxonomy'; // Note that `nwa` currently hardcodes this key to access our state. Don't
// change this unless you absolutely know what you're doing.

export var GLOBAL_SHARED_STATE_KEY = '__nwAnalyticsState';
export var BROWSER_EVENTS_ATTACHED_KEY = '__browserEventsAttached';